module.exports = __webpack_public_path__ + "img/coco-club-07.eb4f035b.jpg";